const loginFields = [
    {
        labelText:"Mobile Number",
        labeFor:"name",
        id:"mobile",
        name:"mobile",
        type:"number",
        
        isRequired:"true",
        placeholder:"98XXXXXXXX"
    },
    {
        labelText:"Password",
        labelFor:"password",
        id:"password",
        name:"password",
        type:"password",
        autoComplete:"current-password",
        isRequired:true,
        placeholder:"Password"   
    },
 
]

const signupFields=[
    {
        labelText:"fistName",
        labelFor:"fistname",
        id:"firstName",
        name:"firstname",
        type:"text",
        autoComplete:"firstname",
        isRequired:true,
        placeholder:"Firstname"   
    },
    {
        labelText:"lastname",
        labelFor:"lastName",
        id:"lastName",
        name:"lastname",
        type:"text",
        autoComplete:"lastname",
        isRequired:true,
        placeholder:"Lastname"   
    },
    {
        labelText:"Email address",
        labelFor:"email-address",
        id:"email",
        name:"email",
        type:"email",
        autoComplete:"email",
        isRequired:true,
        placeholder:"Email address"   
    },
    {
        labelText:"Mobile Number",
        labeFor:"name",
        id:"mobile",
        name:"mobile",
        type:"number",  
        isRequired:"true",
        placeholder:"98XXXXXXXX"
    },
    {
        labelText:"Password",
        labelFor:"password",
        id:"password",
        name:"password",
        type:"password",
        autoComplete:"current-password",
        isRequired:true,
        placeholder:"Password (min. 6 characters)"   
    },

    // {
    //     labelText: "Role",
    //     labelFor: "role",
    //     id: "role",
    //     name: "role",
    //     type: "radio",
    //     isRequired: true,
    //     options: [
    //       { label: "Admin", value: "admin" },
    //       { label: "User", value: "user" },
    //     ],
    //   },
]

export {loginFields,signupFields}